import { Link, } from "react-router-dom";
import { Box, Image, Slide, } from "@chakra-ui/react";

import qr from "../../../../assets/qr.svg";
import { RoutesMap, } from "../../../../routes.tsx";

interface IQRButtonView {
  showButton: boolean;
}

export function QRButtonView({ showButton, }: IQRButtonView,) {
  return (
    <>
      {showButton && (
        <Slide direction="bottom" in={true} style={{ zIndex: 10, bottom: "20px", maxWidth: "74px", margin: "0 auto", }}>
          <Link to={RoutesMap.qr.index}>
            <Box
              as="button"
              w="74px"
              h="74px"
              borderRadius="50%"
              display="flex"
              alignItems="center"
              justifyContent="center"
              bg="white"
              boxShadow="0px 4px 12px rgba(0, 0, 0, 0.10)"
              mx="auto"
            >
              <Image src={qr} />
            </Box>
          </Link>
        </Slide>
      )}
    </>
  );
}
